import { defaultLocale } from "../i18n/provider";
import {
  LOGIN_FAIL,
  LOGIN_FETCH,
  LOGIN_SUCCESS,
  SET_LOCALE,
  SET_PROFILE,
} from "./userActions.constants";

const defaultState = {
  locale: defaultLocale,
  fetching: false,
  email: null,
  admin: false,
  id: null,
  profile: {},
};

const ROLE_ADMIN = 1;
const ROLE_MANAGER = 2;
const ROLE_USER = 3;

export default function (state = defaultState, action) {
  switch (action.type) {
    case LOGIN_FETCH:
      return {
        ...state,
        fetching: true,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        fetching: false,
      };
    case LOGIN_SUCCESS:
      return Object.assign({}, state, {
        email: action.user.userEmail,
        admin: action.user.admin,
        manager: action.user.role <= ROLE_MANAGER,
        id: action.user.userId,
        role: action.user.role,
        affiliation: action.user.affiliation,
        fetching: false,
        profile: action.user,
      });
    case SET_PROFILE:
      return {
        ...state,
        profile: action.profile,
      };
    case "LOGOUT":
      return {
        ...defaultState,
        locale: state.locale, //don't reset the locale
      };
    case SET_LOCALE:
      return {
        ...state,
        locale: action.locale,
      };
    default:
      return state;
  }
}
